import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';

@Component({
    selector: 'app-add-saving',
    templateUrl: './add-saving.component.html',
    styleUrls: ['./add-saving.component.scss'],
    standalone: false
})
export class AddSavingComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @Input() companyBankAccountList: Account[] = [];
  @Input() cashAccountList: Account[] = [];
  @Output() passEntry = new EventEmitter<any>();
  selectedAccountId: number;
  selectedAccountBalance: number;

  @Input() paidByDuitLebih: boolean;

  //2-WAY BINDING INFO
  savingDate: Date;
  remark: string;
  amount = 0;
  disabledSubmit = false;

  ngOnInit(): void {
    this.savingDate = new Date();
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  isFieldNull() {
    const paymentNull = (this.amount == undefined || this.amount == 0);
    const remarkNull = (this.remark == undefined || this.remark == "");
    const selectedAccountIdNull = (this.selectedAccountId == undefined)
    const paymentValid = isNaN(+this.amount);

    return paymentNull || remarkNull || selectedAccountIdNull || paymentValid;
  }

  addSaving() {
    this.disabledSubmit = true;
    const isoTaskDate = (new Date(Number(this.savingDate))).toISOString();

    const data = {
      "amount": this.amount,
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": "SAVING - " + this.amount + "(" + this.remark + ")"
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddSaving(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          // var json = JSON.parse(xhr.responseText);

          const account = new Account(this.selectedAccountId, null, null, null, null, null, null, -this.amount)
          this.passEntry.emit(account)
          this.reset();
          this.sharedService.openAlert("Successfully added saving!", ALERT_TYPE.DANGER);
          window.location.reload();
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  getAccountBalance() {
    let account = this.companyBankAccountList.find(account => account.ID === Number(this.selectedAccountId));
    if (account == undefined)
      account = this.cashAccountList.find(account => account.ID === Number(this.selectedAccountId));

    return account.Balance;
  }

  isBalanceInsufficient(balance: number) {
    // this.sharedService.openAlert(balance);
    if (balance > 0)
      return false;
    else
      return true;
  }

  submit() {
    if (this.isFieldNull()) {
      this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER)
    } else {
      this.addSaving();
    }
  }

  reset() {
    this.activeModal.close();
  }
}
